import { h, Component } from "preact";

// Inspiration https://github.com/preactjs/preact-cli/tree/master/packages/async-loader

class Async extends Component {
    componentWillMount() {
        this.cancelUpdate = false;
        this.props.load.then((c) => {
            setTimeout(() => {
                this.C = c;
                if (!this.cancelUpdate) {
                    this.forceUpdate();
                }
            }, 1000);
        });
    }

    componentWillUnmount() {
        this.cancelUpdate = true;
    }

    render(props, state) {
        const root = props._root_node;

        // placeholder is used when rendering lazy component and
        // because returning null, would skip replacing of _root_node
        let placeholder = null;
        if (root) {
            placeholder = (
                <div
                    dangerouslySetInnerHTML={{
                        __html: root.outerHTML,
                    }}
                />
            );
        }

        return this.C ? this.C.default ? <this.C.default {...props} /> : <this.C {...props} /> : placeholder;
    }
}

export default function lazy_component(load_fce) {
    return ({ children, ...props }) => <Async load={load_fce()} {...props} />;
}
